export const environment = {
  API_BASE_URL: "https://docuty-api-test.insirion.com",
  AUTH_DOMAIN: "docuty-test.eu.auth0.com",
  AUTH_CLIENT_ID: "6gfzF88k9Nm9ywuDkQDQGHTSGxwbORFI",
  AUTH_AUDIENCE: "https://docuty-test.insirion.com",
  ADMIN_PANEL_VERSION: "development-28f1260",
  ADMIN_PANEL_COMMIT_HASH: "28f1260",
  LOADER_COLOR: "#F97316"
}
